import Vue from 'vue'
import { MutationTree } from 'vuex'

import {
	SIDEBAR_TYPE,
	DEFAULT_THEME,
	DEFAULT_LAYOUT_MODE,
	DEFAULT_COLOR,
	DEFAULT_COLOR_WEAK,
	DEFAULT_FIXED_HEADER,
	DEFAULT_FIXED_SIDEMENU,
	DEFAULT_FIXED_HEADER_HIDDEN,
	DEFAULT_CONTENT_WIDTH_TYPE,
	DEFAULT_MULTI_TAB,
} from '../mutation-types'

const app = {
	namespaced: true,
	state: {
		sidebar: true,
		device: 'desktop',
		theme: '',
		layout: '',
		contentWidth: '',
		fixedHeader: false,
		fixSiderbar: false,
		autoHideHeader: false,
		color: null,
		weak: false,
		multiTab: true,
		name: '',
		include: [],
	},
	mutations: {
		includePush(state: any, name: any) {
			const include = [...state.include]
			include.push(name)
			state.include = include
		},
		includeRemove(state: any, name: any) {
			const list = [...state.include]
			const index = list.findIndex(item => item === name)

			if (index !== -1) {
				list.splice(index, 1)
				state.include = list
			}
		},
		SET_SIDEBAR_TYPE: (state: any, type: string) => {
			state.sidebar = type
			Vue.ls.set(SIDEBAR_TYPE, type)
		},
		CLOSE_SIDEBAR: (state: any) => {
			Vue.ls.set(SIDEBAR_TYPE, true)
			state.sidebar = false
		},
		TOGGLE_DEVICE: (state: any, device: string) => {
			state.device = device
		},
		TOGGLE_THEME: (state: any, theme: string) => {
			// setStore('_DEFAULT_THEME', theme)
			Vue.ls.set(DEFAULT_THEME, theme)
			state.theme = theme
		},
		TOGGLE_LAYOUT_MODE: (state: any, layout: string) => {
			Vue.ls.set(DEFAULT_LAYOUT_MODE, layout)
			state.layout = layout
		},
		TOGGLE_FIXED_HEADER: (state: any, fixed: string) => {
			Vue.ls.set(DEFAULT_FIXED_HEADER, fixed)
			state.fixedHeader = fixed
		},
		TOGGLE_FIXED_SIDERBAR: (state: any, fixed: string) => {
			Vue.ls.set(DEFAULT_FIXED_SIDEMENU, fixed)
			state.fixSiderbar = fixed
		},
		TOGGLE_FIXED_HEADER_HIDDEN: (state: any, show: string) => {
			Vue.ls.set(DEFAULT_FIXED_HEADER_HIDDEN, show)
			state.autoHideHeader = show
		},
		TOGGLE_CONTENT_WIDTH: (state: any, type: string) => {
			Vue.ls.set(DEFAULT_CONTENT_WIDTH_TYPE, type)
			state.contentWidth = type
		},
		TOGGLE_COLOR: (state: any, color: string) => {
			Vue.ls.set(DEFAULT_COLOR, color)
			state.color = color
		},
		TOGGLE_WEAK: (state: any, flag: string) => {
			Vue.ls.set(DEFAULT_COLOR_WEAK, flag)
			state.weak = flag
		},
		TOGGLE_MULTI_TAB: (state: any, bool: boolean) => {
			Vue.ls.set(DEFAULT_MULTI_TAB, bool)
			state.multiTab = bool
		},
		setAppName(state: any, name: string) {
			state.name = name
		},
	},
	actions: {
		setSidebar(store: any, type: string) {
			store.commit('SET_SIDEBAR_TYPE', type)
		},
		CloseSidebar(store: any) {
			store.commit('CLOSE_SIDEBAR')
		},
		ToggleDevice(store: any, device: string) {
			store.commit('TOGGLE_DEVICE', device)
		},
		ToggleTheme(store: any, theme: string) {
			store.commit('TOGGLE_THEME', theme)
		},
		ToggleLayoutMode(store: any, mode: string) {
			store.commit('TOGGLE_LAYOUT_MODE', mode)
		},
		ToggleFixedHeader(store: any, fixedHeader: boolean) {
			if (!fixedHeader) {
				store.commit('TOGGLE_FIXED_HEADER_HIDDEN', false)
			}
			store.commit('TOGGLE_FIXED_HEADER', fixedHeader)
		},
		ToggleFixSiderbar(store: any, fixSiderbar: boolean) {
			store.commit('TOGGLE_FIXED_SIDERBAR', fixSiderbar)
		},
		ToggleFixedHeaderHidden(store: any, show: string) {
			store.commit('TOGGLE_FIXED_HEADER_HIDDEN', show)
		},
		ToggleContentWidth(store: any, type: string) {
			store.commit('TOGGLE_CONTENT_WIDTH', type)
		},
		ToggleColor(store: any, color: string) {
			store.commit('TOGGLE_COLOR', color)
		},
		ToggleWeak(store: any, weakFlag: string) {
			store.commit('TOGGLE_WEAK', weakFlag)
		},
		ToggleMultiTab(store: any, bool: boolean) {
			store.commit('TOGGLE_MULTI_TAB', bool)
		},
	},
}

export default app
